export default "__VITE_ASSET__DL_5coST__"